/**
 * Publish gate refusals (Dow Janes, Pavel 2026-08-19): the server NAMES the
 * refusal, so the surface must too. The console's generic toast reads only the
 * STATUS and answers every 409 with "load the fresh state", which is a lie for
 * `edit_base_not_live`: no reload clears it, the repair is a fresh edit of the
 * version the client sees now. The three publish buttons of the deliverables
 * surface (review card, review room, admin version fold) all route their
 * failed response through here and print the sentence beside themselves.
 *
 * 🔴 `t` THROWS on a missing key (F106). A refusal is therefore mapped through
 * an ALLOWLIST, never by probing whether `t()` handed its own key back: an
 * unnamed code would throw inside the click handler and leave the button dead
 * with nothing said. An unnamed failure returns null and stays with the toast.
 */
const PUBLISH_ERROR_CODES = ["edit_base_not_live"] as const;

export async function publishIssueKey(response: Response): Promise<string | null> {
  if (response.ok) return null;
  let code = "";
  try {
    const body = await response.json() as { error?: string };
    if (typeof body.error === "string") code = body.error;
  } catch { /* an unreadable body is the toast's case, not a named one */ }
  return (PUBLISH_ERROR_CODES as readonly string[]).includes(code)
    ? `staffConsole.material.publishError.${code}`
    : null;
}
